export const getTypeLabelForSlug = (
  type: string,
  text: (key: string, fallback: string) => string,
): string => {
  switch (type) {
    case 'line':
      return text('extensions.slugLabels.line', 'Line')
    case 'ring-group':
      return text('extensions.slugLabels.ringGroup', 'Ring Group')
    case 'call-queue':
      return text('extensions.slugLabels.callQueue', 'Call Queue')
    case 'conference-room':
      return text('extensions.slugLabels.conferenceRoom', 'Conference Room')
    case 'virtual-fax':
      return text('extensions.slugLabels.virtualFax', 'Virtual Fax Machine')
    case 'shared-voicemail':
      return text(
        'extensions.slugLabels.sharedVoicemail',
        'Shared Voicemail Box',
      )
    default:
      return type
  }
}

export const getListLabelForSlug = (
  type: string,
  text: (key: string, fallback: string) => string,
): string => {
  switch (type) {
    case 'line':
      return text('extensions.listLabels.lines', 'Lines')
    case 'ring-group':
      return text('extensions.listLabels.ringGroups', 'Ring groups')
    case 'call-queue':
      return text('extensions.listLabels.callQueues', 'Call queues')
    case 'conference-room':
      return text('extensions.listLabels.conferenceRooms', 'Conference rooms')
    case 'virtual-fax':
      return text('extensions.listLabels.virtualFax', 'Virtual fax')
    case 'shared-voicemail':
      return text('extensions.listLabels.sharedVoicemail', 'Shared Voicemail')
    default:
      return text('extensions.viewModes.extensions', 'Extensions')
  }
}
